const state = {
    loading: false,
    listMindset: [],
};

export default state;